module.exports = __webpack_public_path__ + "static/media/valencia-10.1c37feaf.jpg";